import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function OfflineBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-[9999] bg-error px-4 py-2 text-center text-sm font-medium text-error-foreground"
    >
      Sin conexión a internet. Verifica tu red.
    </div>
  );
}
